// @ts-ignore
import useApi from "./ServiceClient.tsx";
// @ts-ignore
import { config } from "./config.tsx";

export const useCatalogueManagement = () => {
    const { GET, POST, DELETE, dynamicRequest } = useApi(); // Use API methods inside a React hook
    
    const getCatalogueItemsPageWise = (data) => {
        const response = POST( 
            config?.catalogue_management?.END_POINTS?.ITEMS_PAGED,
            data
        );
        return response;
    };

    const getCatalogueItem = (email) => {
        const response = GET(
            `${config?.catalogue_management?.END_POINTS?.ITEM_GET}/${email}`
        );
        return response;
    };

    const createCatalougeItem = (data) => {
        const response = POST(
            config?.catalogue_management?.END_POINTS?.ITEM_CREATE,
            data
        );
        return response;
    };

    const updateCatalougeItem = (data) => {
        const response = POST(
            config?.catalogue_management?.END_POINTS?.ITEM_UPDATE,
            data
        );
        return response;
    };

    const deleteCatalougeItem = (data) => {
        const response = DELETE(config?.catalogue_management?.END_POINTS?.ITEM_DELETE);
        return response;
    };

    const getCatalogueTypes = (tenantId) => {
        const response = GET(`${config?.catalogue_management?.END_POINTS?.ITEM_CATALOGUE}/${tenantId}`);
        return response;
    }

    const createCatalogueType = (data) => {
        const response = POST(
            config?.catalogue_management?.END_POINTS?.ITEM_TYPE_CREATE,
            data
        );
        return response;
    }

    const deleteCatalougeType = (id) => {
        const response = DELETE(`${config?.catalogue_management?.END_POINTS?.ITEM_TYPE_DELETE}/${id}`);
        return response;
    };

    const updateCatalogueType = (data) => {
        const response = POST(
            config?.catalogue_management?.END_POINTS?.ITEM_TYPE_UPDATE,
            data
        );
        return response;
    }

    return {
        getCatalogueItemsPageWise,
        getCatalogueItem,
        createCatalougeItem,
        updateCatalougeItem,
        deleteCatalougeItem,
        getCatalogueTypes,
        createCatalogueType,
        deleteCatalougeType,
        updateCatalogueType
    };
};
